<template>
  <portal :to="target">
    <transition :name="transitionType">
      <article class="bzm_modal_wrap" :class="[{ full_modal: full }, { footer_fixed: footerFixed }, classNames]">
        <div class="bzm_modal">
          <div class="bzm_modal_header" v-if="$slots.header">
            <strong class="title">
              <slot name="header">모달 타이틀</slot>
            </strong>
            <button type="button" class="bzm_close" @click="$emit('close')">
              <i class="ico24_close"></i>
              <span class="txt_hidden">닫기</span>
            </button>
          </div>

          <section class="bzm_modal_contents" ref="wrapRef" body-scroll-lock-ignore>
            <slot />
            <slot name="contents" />
          </section>

          <div class="bzm_modal_footer" v-if="$slots.footer">
            <slot name="footer" />
          </div>
        </div>
        <div v-if="dimClose" class="modal_dim" @click="$emit('close')"/>
      </article>
    </transition>
  </portal>
</template>

<script>
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

export default {
  inheritAttrs: false,

  props: {
    /** 전체화면 표시 여부 */
    full: {
      type: Boolean,
      default: false,
    },
    /** footer영역 하단 고정 여부 */
    footerFixed: {
      type: Boolean,
      default: false,
    },
    classNames: {
      type: [Object, Array, String],
      default: '',
    },
    target: {
      type: String,
      default: 'modal',
    },
    transitionType: {
      type: String,
      default: 'fade',
    },
    dimClose: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    //don't pull android
    androidLock() {
      const target = document.body;
      if(this.full && target.classList.contains('is_android')) {        
        target.classList.add('dont_pull');
      };
    },
    removeAndroidLock() {
      const target = document.body;
      const modalLen = document.querySelectorAll('.full_modal').length;
      if(this.full && target.classList.contains('is_android') && modalLen < 2) {        
        target.classList.remove('dont_pull');
      };
    },
    //page modal
    findPageModal() {
      if(this.$el.previousSibling === null && document.body.classList.contains('is_safari')) {
        document.body.classList.add('page_modal');
      }
    },
    resetPageModal() {
      document.body.classList.remove('page_modal');
    },

    //remove default lock
    removeScroll() {
      const wrap = document.body;
      const removePoint = document.getElementsByClassName('bzm_modal_wrap').length > 1;
      if(!removePoint) {
        wrap.classList.remove('modal_lock')
      }
      console.log(document.getElementsByClassName('bzm_modal_wrap'))
    },
  },

  mounted() {
    //scroll lock
    this.$nextTick(() => {
      //const wrap = document.body;
      //wrap.classList.add('modal_lock');

      disableBodyScroll(this.$refs.wrapRef, {
        allowTouchMove(target) {
          let el = target;
          while (el && el !== document.body) {
            if (el.getAttribute('body-scroll-lock-ignore') === '') return true;
            el = el.parentElement;
          }
        },
      });
    });

    //don't pull
    this.androidLock();
    //page modal
    this.findPageModal();
  },

  beforeDestroy() {
    //this.removeScroll();
    //scroll lock remove
    enableBodyScroll(this.$refs.wrapRef);
    //don't pull
    this.removeAndroidLock();
    this.resetPageModal();
  },
};
</script>

<style></style>
